<script lang="ts">
	import { get } from 'svelte/store';
	import { format } from 'svelte-i18n';
	// Design system components
	import {
		ExpandableTable,
		ExpandableTableCol,
		ExpandableTableRow,
		Icon,
		Text,
	} from '@Shelly/shelly-design-system/index';
	// Helpers
	import {
		formatDuration,
		type SessionEvents,
	} from 'src/helpers/xt1_helpers/ev_charger/ev_charger_session_info_helpers';
	import { dateFormat } from 'src/helpers/date_helper';
	//Types
	import type { Device } from 'src/types/Device';
	import EvChargeEventLogTableChart from './EvChargeEventLogTableChart.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device: Device,
		events: SessionEvents[] = [];

	const colWidths = ['1fr', '90px'];
	const headingElements = [
		{
			id: 'timestamp',
			title: get(format)('timestamp', { default: 'timestamp' }),
		},
		{
			id: 'info',
			title: get(format)('short_info', { default: 'info' }),
			icon: 'fas fa-clock',
		},
	];
	const onExpand = (i: number) => {
		expandedRows = expandedRows.map((row, index) => {
			if (index === i) {
				return {
					...row,
					expanded: !row.expanded,
				};
			} else {
				return row;
			}
		});
	};

	const onExpandAll = () => {
		expandAll = !expandAll;
		expandedRows = expandedRows.map((row) => {
			return {
				...row,
				expanded: expandAll,
			};
		});
	};

	let isMobile: boolean;
	let expandAll = false;
	let expandedRows = events.map((event) => {
		return {
			heading: false,
			expanded: false,
			event,
			colData: [{ text: dateFormat(event.session_end, 'd-m-y') }, { text: formatDuration(event) }],
		};
	});
</script>

<ExpandableTable {colWidths} rowsColor={$showNewLayout ? 'color-0' : 'color-base'} bind:isMobile>
	<ExpandableTableRow heading expanded={expandAll} on:expand={onExpandAll}>
		{#each headingElements as col, i}
			<ExpandableTableCol>
				{#if col.icon}
					<Icon class="width-full justify-content-end" icon={col.icon} size="s" />
				{:else if col.title}
					<Text breakWord styleType="body-small" class="text-capitalize text-bold">
						{col.title}
					</Text>
				{/if}
			</ExpandableTableCol>
		{/each}
	</ExpandableTableRow>
	{#each expandedRows as row, i}
		<ExpandableTableRow
			on:expand={() => onExpand(i)}
			heading={row.heading}
			expanded={row.expanded}
			rowClickExpand
		>
			{#each row.colData as col, i}
				<ExpandableTableCol align={i == 0 ? 'left' : 'right'}>
					<Text styleType="body-small">{col.text}</Text>
				</ExpandableTableCol>
			{/each}
			<EvChargeEventLogTableChart slot="expandableContent" {device} event={row.event} />
		</ExpandableTableRow>
	{/each}
</ExpandableTable>
